/*
 * Copyright (c) 2022 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import { Header } from "@scuf/common";
import React from "react";
import { IFCPDIYGatewayManagementProps } from "../../stores/GatewayManager/IGatewayRegistrationInterfaces";

export const FCPDIYGatewayManagementHeader: React.FC<
    IFCPDIYGatewayManagementProps
> = (props: IFCPDIYGatewayManagementProps) => {

    /**
     * renderLogoutItem() function will render LogOut Item as part of UserProfile
     * only If User is logged In
     * @returns
     */
    const renderLogoutItem = () => {
        return (
            <>
                <Header.UserProfile.Item onClick={props!.logout}>
                    Log out
                </Header.UserProfile.Item>
            </>
        )
    }

    return (
        <>
            <div className="application-header">
                <Header
                    title="Connect"
                    logo={false}
                    isForge={true}
                    menu={false}
                    className="ui-application-header"
                >
                    <Header.UserProfile
                        firstName={props.userInfo!.firstName}
                        lastName={props.userInfo!.lastName}
                    >
                        {props.logout ? renderLogoutItem() : ""}
                        <Header.UserProfile.Item
                            onClick={() => {
                                window.open("/license.txt");
                            }}
                        >
                            License
                        </Header.UserProfile.Item>
                    </Header.UserProfile>
                </Header>
            </div>
        </>
    );
};
